export default {
    mailCustomer: [],
    infoDB: {}
}